/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import moment from "moment";
import validator from "validator";
import confirm from "../../../components/DialogComponent/confirm";
import { getuniqueId, splitTimeValues } from "../../../services/helpers";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import SingleSelect from "../../../components/SelectField/SingleSelect";
const CreateShift = (props) => {
  const ShiftDays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const [isEditMode, setEditmode] = React.useState(false);
  const [shiftData, setShiftData] = React.useState({});
  const [shiftDataError, setShiftDataError] = React.useState({});
  const [shiftDaysstate, setShiftDays] = React.useState();
  const [startTime, setStartTime] = React.useState();
  const [endTime, setEndTime] = React.useState();
  const { allShifts } = props;

  const initEditdata = () => {
    let shiftData = props?.shiftData ? props?.shiftData : {};
    if (
      allShifts?.length > 0 &&
      typeof props?.edit !== "undefined" &&
      props?.edit !== ""
    ) {
      setEditmode(true);
      let isCustom = allShifts?.filter(
        (asitem) => asitem.title === props?.shiftData?.title
      );

      if (!isCustom.length > 0) {
        shiftData.shift = "Custom Shift";
        shiftData.customShiftName = props?.shiftData?.title;
      } else {
        shiftData.shift = props?.shiftData?.title;
      }
      let sTime = splitTimeValues(shiftData?.startTime);
      let startTimeedit = moment().set('hour', sTime?.hour).set('minute', sTime?.minute);
      setStartTime(startTimeedit);
      let eTime = splitTimeValues(shiftData?.endTime);
      let endTimeedit = moment().set('hour', eTime?.hour).set('minute', eTime?.minute);
      setEndTime(endTimeedit);
    }
    setShiftData({ ...shiftData });

  };
  useEffect(() => {
    if (allShifts?.length > 0) initEditdata();
  }, [allShifts, props?.edit, props?.shiftData]);

  const handleInputChange = (event) => {
    const {
      target: { name, value },
    } = event;

    let shiftDatas = { ...shiftData, [name]: value };
    let shiftDatasError = { ...shiftDataError, [name]: "" };
    if (name === "shift") {
      let alltitlse = props.shiftsList.map((title) => {
        let ct;
        if (title.title === shiftDatas.shift) {
          ct = title.title

        }
        return ct;
      });

      alltitlse = alltitlse.filter(function (element) {
        return element !== undefined;
      });
      let totalcon = alltitlse.length;

      shiftDatas = { ...shiftDatas, customShiftName: "" };
      shiftDatas = { ...shiftDatas, titlen: totalcon };
      shiftDatasError = { ...shiftDatasError, customShiftName: "" };

    }


    setShiftData(shiftDatas);
    setShiftDataError(shiftDatasError);

  };



  const handleShiftCheckChange = (event) => {
    const {
      target: { name, checked },
    } = event;
    let selectedDays = shiftData?.day ? shiftData?.day : [];
    let finditem = selectedDays.includes(name);
    if (checked && !finditem) {
      selectedDays = [...selectedDays, name];
    } else if (finditem && !checked) {
      selectedDays = [...selectedDays.filter((ditem) => ditem !== name)];
    }



    setShiftData({ ...shiftData, day: selectedDays });
    setShiftDataError({ ...shiftDataError, day: "" });



  };

  const validate = () => {

    let isvalid = true;
    let errorMessages = {};

    if (!shiftData?.shift) {
      isvalid = false;
      errorMessages.shift = "Shift is required";
    } else if (shiftData?.shift === "Custom Shift") {
      if (!shiftData?.customShiftName) {
        isvalid = false;
        errorMessages.customShiftName = "Custom Shift Name is required";
      } else if (!validator.isLength(shiftData.customShiftName, { min: 1, max: 25 })) {
        isvalid = false;
        errorMessages.customShiftName = "Name must be 25 characters or less";
      }
    }

    // if (!shiftData?.day?.length) {
    //   isvalid = false;
    //   errorMessages.day = "At least one day must be selected";
    // }

    setShiftDataError(errorMessages);
    return isvalid;
  };

  const allShiftsOptions = [
    ...allShifts,
    {
      title: "Custom Shift",
      value: "Custom Shift",
    },
  ].map((ShiftItem) => {
    return {
      label: `${ShiftItem.title}`,
      value: ShiftItem?.title,
      shiftItem: ShiftItem,
    };
  });
  const clearShiftForm = () => {
    setShiftData({});
    setShiftDataError({});
    setStartTime(null);
    setEndTime(null);
    // setShiftDays(
    //   shiftDaysstate?.map((sitem) => {
    //     return { ...sitem, checked: false };
    //   })
    // );
  };

  const proceedtoCreateShift = (saveShiftData) => {
  const isOpenTasksVariant = /^opentasks(?:(?:\s*-+\s*|)(?:[1-9]|10))?$/i.test(saveShiftData?.shift);
    let startDateF = "";
    let endDateF = "";
    let newShift = {
      title:
        saveShiftData?.shift === "Custom Shift"
          ? saveShiftData?.customShiftName
          : saveShiftData?.shiftData?.title,
      titlen: saveShiftData?.titlen,
      shiftId: saveShiftData?.shiftId,
      // day: saveShiftData?.day,
      status: saveShiftData?.status,
      startTime: moment(startTime).format('hh:mm A'),
      endTime: moment(endTime).format('hh:mm A'),
      startDate: startDateF,
      endDate: endDateF,
      opentasksstatus: isOpenTasksVariant ? true : false,
    };

    if (props.onCreateShift) {
      if (isEditMode) {
        props.onCreateShift(props?.edit, newShift);
      } else {
        props.onCreateShift(newShift);
      }
      props?.onClose?.();
    }

    if (!isEditMode) clearShiftForm();
  };

  const saveShift = () => {
    if (true === validate()) {
      let newid = getuniqueId("shift");
      if (isEditMode === true) {
        newid = props?.edit;
      }
      let selectedShiftData = allShiftsOptions?.filter(
        (sftItem) => sftItem?.value === shiftData?.shift
      );
      selectedShiftData = selectedShiftData[0].shiftItem;

      let saveShiftData = {
        shiftId: newid,
        shift: shiftData?.shift,

        // day: shiftData?.day,
        shiftData: selectedShiftData,
        customShiftName: shiftData?.customShiftName?.trim() || null,
        titlen: shiftData?.titlen,
        status: true,
      };

      if (props?.shiftsList?.length > 0) {
        let isfind = false;

        props?.shiftsList?.filter((sitem) => {

          if (
            sitem?.day?.join("-") === saveShiftData.day?.join("-") &&
            sitem?.shift === saveShiftData.shift
          ) {
            isfind = true;
          }

          return sitem;
        });

        if (isfind && !isEditMode) {
          confirm("Do you want to create same shift again?").then(() => {
            proceedtoCreateShift(saveShiftData);
          });
        } else {
          proceedtoCreateShift(saveShiftData);
        }
      } else {
        proceedtoCreateShift(saveShiftData);
      }
    }
  };
  return (
    <>
      <div
        className={`stepSectionContent`}
      >
        <div className="formFieldwrap w-50 pr-20">
            <label className="text-sm font-medium mb-1.5 block">Shift Type</label>
          <SingleSelect
            placeholder="Select Shift *"
            value={shiftData?.shift ? shiftData?.shift : ""}
            className={`field`}
            name={"shift"}
            onChange={handleInputChange}
            options={allShiftsOptions}
          />
          {typeof shiftDataError?.shift !== "undefined" &&
            shiftDataError?.shift !== "" && (
              <span className="small error color-danger">
                {shiftDataError?.shift}
              </span>
            )}
        </div>
        {shiftData?.shift && shiftData?.shift === "Custom Shift" && (
          <div className="formFieldwrap w-50 pr-20">
            <Input
              name="customShiftName"
              id="customShiftName"
              placeholder="Custom Shift Name"
              onChange={handleInputChange}
              value={
                shiftData?.customShiftName ? shiftData?.customShiftName : ""
              }
            />
            {typeof shiftDataError?.customShiftName !== "undefined" &&
              shiftDataError?.customShiftName !== "" && (
                <span className="small error color-danger">
                  {shiftDataError?.customShiftName}
                </span>
              )}
          </div>
        )}

        {/* <div className="mt-20">
          <h5 className="stepSectionTitle w-50">Shift Details</h5>
          <div className="stepSectionContent w-50 pl-15">
            <div className="formFieldwrap">
              <FormControl component="div" className={"checkboxfieldwrap"}>
                <FormLabel component="legend" className={"checkboxfieldlabel"}>
                  <strong>Select Day</strong>
                </FormLabel>
                <div className={"checkboxGroupwrap"}>
                  <FormGroup row>
                    {ShiftDays.map((shiftItem, index) => {
                      return (
                        <FormControlLabel
                          key={"shiftitemkey" + index}
                          control={
                            <Checkbox
                              size="small"
                              color="primary"
                              checked={
                                shiftData?.day
                                  ? shiftData?.day.includes(shiftItem)
                                  : false
                              }
                              onChange={handleShiftCheckChange}
                              name={shiftItem}
                            />
                          }
                          label={shiftItem}
                        />
                      );
                    })}
                  </FormGroup>
                </div>
              </FormControl>
              {typeof shiftDataError?.day !== "undefined" &&
                shiftDataError?.day !== "" && (
                  <FormHelperText className="small error color-danger">
                    {shiftDataError?.day}
                  </FormHelperText>
                )}
            </div>

            {typeof shiftDataError?.shiftErrorGlob !== "undefined" &&
              shiftDataError?.shiftErrorGlob !== "" && (
                <FormHelperText className="small error color-danger">
                  {shiftDataError?.shiftErrorGlob}
                </FormHelperText>
              )}
            {typeof shiftDataError?.startTime !== "undefined" &&
              shiftDataError?.startTime !== "" && (
                <FormHelperText className="small error color-danger">
                  {shiftDataError?.startTime}
                </FormHelperText>
              )}
            {typeof shiftDataError?.endTime !== "undefined" &&
              shiftDataError?.endTime !== "" && (
                <FormHelperText className="small error color-danger">
                  {shiftDataError?.endTime}
                </FormHelperText>
              )}
            {typeof shiftDataError?.diff !== "undefined" &&
              shiftDataError?.diff !== "" && (
                <FormHelperText className="small error color-danger">
                  {shiftDataError?.diff}
                </FormHelperText>
              )}
          </div>
        </div> */}

        <div className="d-flex flex-space-between mt-30">
          <Button
            variant="outline"
            className="mt-2 sm:mt-0 w-full sm:w-auto text-[#020817] dark:text-white border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700"
             onClick={async () => {
              try {
                await confirm("Are you sure you want to cancel? This won't be saved or created.");
                props?.onClose();
              } catch {
                // user clicked Cancel – do nothing
              }
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            className="w-full sm:w-auto ml-20 bg-green color-white"
            onClick={saveShift}
          >
            {isEditMode === true ? "Update Shift" : "Save Shift"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default CreateShift;
